import { postRoute } from "../client"
type ShopBuyResult = { success: true; coins: number } | { success: false; error: string }
export const shopBuyRoute = postRoute<ShopBuyResult>("/api/shop/buy")
